module.exports = __webpack_public_path__ + "static/media/36x182.39ece554.png";